import { useForm, useWatch } from 'react-hook-form';
import { addNarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useQueryGetKeyActivities } from 'api/queries/getKeyActivities.query';
import { useQueryGetKeyActivitiesTags } from 'api/queries/getKeyActivitiesTags.query';

import { usePinboardWidgetWrapperContext } from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/context/widgetWrapperContext';
import { statusOptions } from 'components/widgets/KeyActivities/components/filter.utils';

export interface FormProps {
    name: string;
    status: ISelectOption<string>[];
    moreFilter: ISelectOption<string>[];
    nextDate: ISelectOption<string>;
    tags: readonly ISelectOption<number>[];
}

export const useKeyActivitiesProvider = ({
    componentKey,
    widgetId,
    contractId,
    latestVersionId,
    compareVersionId,
    globalFilterData,
    localFilters,
}) => {
    const { isGenerativeAi } = usePinboardWidgetWrapperContext();

    const getKeyActivitiesTags = useQueryGetKeyActivitiesTags({ contractId });

    const form = useForm<FormProps>({
        defaultValues: {
            tags: [],
            name: '',
            status: statusOptions.filter((item) => item.id !== 3),
            moreFilter: [],
            nextDate: {
                label: 'ALL',
                value: '-1',
            },
        },
    });

    const formValues = form.watch();

    const source = widgetId ? localFilters : { ...globalFilterData, ...formValues };

    const getKeyActivities = useQueryGetKeyActivities({
        contractId: contractId,
        latestVersionId: latestVersionId,
        compareVersionId: compareVersionId,
        filterData: {
            filters: [],
        },
        tagIdList: widgetId
            ? localFilters?.tags?.map((item) => item.value) || []
            : getKeyActivitiesTags.data?.map((item) => item.tagId) || [],
        ...addNarrativeRequest(isGenerativeAi, componentKey, widgetId),
    });

    const pillsData = {
        activityCodes: source?.activityCodes?.filter((item) => !item.value?.isExclude).map((i) => i.value?.name),
        activityCodesExclude: source?.activityCodes?.filter((item) => item.value?.isExclude).map((i) => i.value?.name),
        milestoneFragnet: source?.milestoneFragnet,
        wbs: source?.wbs,
        tags: source?.tags?.map((i) => i.label),
        name: source?.name,
        statusFilter: source?.status?.map((item) => item.label),
        status: source?.moreFilter?.map((i) => i.label),
        numOfMonths: source?.nextDate?.label,
    };
    const { pillsList: pills } = useGlobalFiltersHook({ widgetId, source: pillsData, latestVersionId });

    return {
        ui: {
            state: { ...source },
            pills,
            form,
        },
        api: {
            getKeyActivitiesTags,
            getKeyActivities,
        },
    };
};
